import styled from 'styled-components';

export const ButtonsList = styled.div`
  button {
    margin-right: 1em;
    margin-bottom: 0.25em;

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export const ButtonGroup = styled.div`
  button {
    border-radius: 0;

    &:first-of-type {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    &:last-of-type {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }
`;
